/* global angular */
( function () {
	'use strict';

	function groupPagerFactory () {
		var focusedModel, isValidStatus;

		function get () {
			return focusedModel;
		}

		function getValidityForm ( frm ) {
			if ( ( frm || {} ).hasOwnProperty( '$valid' ) ) {
				return frm.$valid;
			}
			return true;
		}

		function getValidity () {
			return getValidityForm( isValidStatus );
		}

		function set ( newFocusModel ) {
			if ( getValidity() ) {
				focusedModel = newFocusModel;
			}
		}

		function isFocusedModel ( extFocusModel ) {
			return focusedModel === extFocusModel;
		}

		function reset () {
			focusedModel  = null;
			isValidStatus = null;
		}

		function setValid ( extIsValidStatus ) {
			isValidStatus = extIsValidStatus;
		}

		reset();

		return {
			'get'   : get,
			'set'   : set,
			'reset' : reset,

			'setValid' : setValid,
			'isValid'  : getValidity,

			'isFocusedModel'  : isFocusedModel,
			'getValidityForm' : getValidityForm
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'groupPagerFactory', groupPagerFactory );
} )( );
